import { render, staticRenderFns } from "./UploadJsonModal.vue?vue&type=template&id=4f2d01ec&scoped=true"
import script from "./UploadJsonModal.vue?vue&type=script&lang=ts"
export * from "./UploadJsonModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d01ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2d01ec')) {
      api.createRecord('4f2d01ec', component.options)
    } else {
      api.reload('4f2d01ec', component.options)
    }
    module.hot.accept("./UploadJsonModal.vue?vue&type=template&id=4f2d01ec&scoped=true", function () {
      api.rerender('4f2d01ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/UploadJsonModal.vue"
export default component.exports